import axios from "axios";

const GetContracters = async () => {
  return axios.get("JobAllocation/GetContracters");
};

const GetJobCard = async (date, contractorCode) => {

  let formData = new FormData();
  formData.append("P_DATE", date);
  formData.append("P_CONTRACTOR_CODE", contractorCode);

  let config = {
    method: "post",
    url: "JobAllocation/GetJobCard",
    data: formData,
  };

  return axios.request(config).then((response) => {
    return response;
  });
};

const GetUnAssignedList = async (date, contractorCode) => {

  let formData = new FormData();
  formData.append("P_DATE", date);
  formData.append("P_CONTRACTOR_CODE", contractorCode);

  let config = {
    method: "post",
    url: "JobAllocation/GetUnAssignedList",
    data: formData,
  };

  return axios.request(config).then((response) => {
    return response;
  });
};

const GetAllocatedEmp = async (date, contractorCode) => {
  return axios.get("JobAllocation/GetAllocatedEmp", {
    params: {
      p_contractor_code: contractorCode,
      p_date: date,
    },
  });
};

export default {
  GetContracters,
  GetJobCard,
  GetUnAssignedList,
  GetAllocatedEmp,
};
